import { FlattenedPermission } from '../base/flattened-permission';
import { PermissionMap } from '../base/permission-map';

export class InternalUserPermissionMap extends PermissionMap {
  public map: Map<number, FlattenedPermission> = new Map<number, FlattenedPermission>();

  constructor() {
    super();
    this.map.set(1001, new FlattenedPermission('viewMemberSubmissions'));
    this.map.set(1002, new FlattenedPermission('viewRemittances'));
    this.map.set(1003, new FlattenedPermission('createAndEditRemittances'));
    this.map.set(1004, new FlattenedPermission('viewRemittanceDetails'));
    this.map.set(1005, new FlattenedPermission('viewMembersTable'));
    this.map.set(1006, new FlattenedPermission('createMembers'));
    this.map.set(1007, new FlattenedPermission('viewMemberDetails'));
    this.map.set(1008, new FlattenedPermission('viewMemberFullSin'));
    this.map.set(1009, new FlattenedPermission('viewMemberAccounts'));
    this.map.set(1010, new FlattenedPermission('viewMemberEmploymentHistory'));
    this.map.set(1011, new FlattenedPermission('createMemberEmploymentHistory'));
    this.map.set(1012, new FlattenedPermission('editMemberEmploymentHistory'));
    this.map.set(1013, new FlattenedPermission('viewEmployersTable'));
    this.map.set(1014, new FlattenedPermission('createEmployers'));
    this.map.set(1015, new FlattenedPermission('viewEmployerDetails'));
    this.map.set(1016, new FlattenedPermission('viewEmployerMembers'));
    this.map.set(1017, new FlattenedPermission('viewEmployerAccounts'));
    this.map.set(1018, new FlattenedPermission('viewInternalUsersTable'));
    this.map.set(1019, new FlattenedPermission('createInternalUsers'));
    this.map.set(1020, new FlattenedPermission('viewInternalUserDetails'));
    this.map.set(1021, new FlattenedPermission('editInternalUserDetails'));
    this.map.set(1022, new FlattenedPermission('viewInternalUserSubmissionPermissions'));
    this.map.set(1023, new FlattenedPermission('editInternalUserSubmissionPermissions'));
    this.map.set(1024, new FlattenedPermission('viewInternalRoles'));
    this.map.set(1025, new FlattenedPermission('viewInternalRoleDetails'));
    this.map.set(1026, new FlattenedPermission('viewAlertsTable'));
    this.map.set(1027, new FlattenedPermission('createAlerts'));
    this.map.set(1028, new FlattenedPermission('viewAlertDetails'));
    this.map.set(1029, new FlattenedPermission('editAlertDetails'));
    this.map.set(1030, new FlattenedPermission('viewReleaseNotesTable'));
    this.map.set(1031, new FlattenedPermission('createReleaseNotes'));
    this.map.set(1032, new FlattenedPermission('viewReleaseNoteDetails'));
    this.map.set(1033, new FlattenedPermission('editReleaseNoteDetails'));
    this.map.set(1034, new FlattenedPermission('editAcceptingSubmissions'));
    this.map.set(1035, new FlattenedPermission('viewMemberAccountDetails'));
    this.map.set(1036, new FlattenedPermission('viewAnnuityRates'));
    this.map.set(1037, new FlattenedPermission('createAnnuityRates'));
    this.map.set(1038, new FlattenedPermission('editAnnuityRates'));
    this.map.set(1039, new FlattenedPermission('viewEmployerSubmissions'));
  }
}
